import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import List from './List';
import CompareYears from './CompareYears';
import './PlanningActual.css';
import FiltePlanningActual from './FiltePlanningActual';
import { RightsAccess, checkArray } from '../../Components/helper';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

function PlanningActual() {
  const { CheckActionPermission, CheckModulePermission } = useComponent();
  const reducer = useSelector((reducerstate) => reducerstate);
  const { t } = useTranslation('common');

  const {
    Users: { logInRights },

    UserDetails: { isCompanyAdminLoggedIn },
  } = reducer;
  const { planningBottomUpRight, planningTopsDownRight } = RightsAccess();
  const [state, setState] = useState({
    isLoading: false,
    errorIndex: [],
    categoryYear: null,
    addEditAccess: CheckActionPermission(logInRights, 'planning', 'topDown', 'addEdit'),
    deleteAccess: CheckActionPermission(logInRights, 'planning', 'topDown', 'delete'),
    bottmUpDisplay: CheckModulePermission(logInRights, 'planning', 'bottomUp', isCompanyAdminLoggedIn),
    topsDownDisplay: CheckModulePermission(logInRights, 'planning', 'topDown', isCompanyAdminLoggedIn),
  });
  const { categoryYear, addEditAccess, bottmUpDisplay, topsDownDisplay } = state;

  const getFilterData = (data) => {
    if (data?.year && checkArray(data?.categoryOne)) {
      setState((prevData) => ({
        ...prevData,
        categoryYear: data,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        categoryYear: null,
      }));
    }
  };

  const mainRendering = () => {
    return state.categoryYear ? (
      <List categoryYear={state?.categoryYear} addEditAccess={addEditAccess} />
    ) : (
      <p className="text-center mt-3">{t('PLANNING_ACTUAL.NO_RECORDS_FOUND')}</p>
    );
  };

  return (
    <form>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">
            {t('PLANNING_ACTUAL.MODAL_TITLE')} {categoryYear?.seasonText?.name && `- ${categoryYear?.seasonText?.name}`} {categoryYear?.year}
          </h4>
        </div>
        <div className="search-filter">
          <FiltePlanningActual setPlanningState={setState} planningState={state} filterData={(data) => getFilterData(data)} />
        </div>
      </div>
      <Container fluid className="d-flex justify-content-end mb-4 mt-3">
        {planningTopsDownRight && topsDownDisplay && (
          <Link className="cursor-pointer text-dark text-decoration-none btn-active btn btn-page-filter" to="/planning/planning-actual">
            {t('PLANNING_ACTUAL.TOPS_DOWN')}
          </Link>
        )}
        {bottmUpDisplay && planningBottomUpRight && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn btn-page-filter" to="/planning/planning-bottomup">
            {t('PLANNING_ACTUAL.BOTTOMS_UP')}
          </Link>
        )}
      </Container>
      <div>{checkArray(state?.categoryYear?.selectedCompareYears) ? <CompareYears categoryYear={state.categoryYear} /> : mainRendering()}</div>
    </form>
  );
}

export default PlanningActual;
